// import React, { useRef } from 'react';
// import { useScroll, useTransform, motion } from 'framer-motion';
// import styles from './style.module.scss';

// import img from '../assets/images/panda.jpg'
// import img1 from '../assets/images/officestudio.png'
// import img2 from '../assets/images/funny.jpg'
// import img3 from '../assets/images/google.jpg'
// import img4 from '../assets/images/wix.jpg'
// import img5 from '../assets/images/silencio.png'
// import img6 from '../assets/images/wix.jpg'
// import img7 from '../assets/images/silencio.png'


// const slider1 = [
//   {
//     color: "#e3e5e7",
//     src: img,
//   },
//   {
//     color: "#d6d7dc",
//     src: img1,
//   },
//   {
//     color: "#e3e3e3",
//     src: img2,
//   },
//   {
//     color: "#21242b",
//     src: img3,
//   },
// ];

// const slider2 = [
//   {
//     color: "#d4e3ec",
//     src: img4,
//   },
//   {
//     color: "#e5e0e1",
//     src: img5,
//   },
//   {
//     color: "#d7d4cf",
//     src: img6,
//   },
//   {
//     color: "#e1dad6",
//     src: img7,
//   },
// ];

// export default function Index() {
//   const container = useRef(null);
//   const { scrollYProgress } = useScroll({
//     target: container,
//     offset: ["start end", "end start"],
//   });

//   const x1 = useTransform(scrollYProgress, [0, 1], [0, 150]);
//   const x2 = useTransform(scrollYProgress, [0, 1], [0, -150]);
//   const height = useTransform(scrollYProgress, [0, 0.9], [50, 0]);

//   return (
//     <div ref={container} className={styles.slidingImages}>
//       <motion.div style={{ x: x1 }} className={styles.slider}>
//         {slider1.map((project, index) => (
//           <div key={index} className={styles.project} style={{ backgroundColor: project.color }}>
//             <div className={styles.imageContainer}>
//               <img fill={true} alt="imag" src={project.src} />
//             </div>
//           </div>
//         ))}
//       </motion.div>
//       <motion.div style={{ x: x2 }} className={styles.slider}>
//         {slider2.map((project, index) => (
//           <div key={index} className={styles.project} style={{ backgroundColor: project.color }}>
//             <div key={index} className={styles.imageContainer}>
//               <img  fill={true} alt="phot" src={project.src} />
//             </div>
//           </div>
//         ))}
//       </motion.div>
//       <motion.div style={{ height }} className={styles.circleContainer}>
//         <div className={styles.circle}></div>
//       </motion.div>
//     </div>
//   );
// }



import React, { useRef } from 'react';
import { useScroll, useTransform, motion } from 'framer-motion';
import YouTubeEmbed from './YouTubeEmbed'; // Make sure to adjust the path accordingly
import { slider1, slider2 } from './data'; // Import the updated data
import styles from './style.module.scss';
import LocalVideoEmbed from './YouTubeEmbed';

export default function Index() {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start end", "end start"],
  });

  const x1 = useTransform(scrollYProgress, [0, 1], [0, 150]);
  const x2 = useTransform(scrollYProgress, [0, 1], [0, -150]);
  const height = useTransform(scrollYProgress, [0, 0.9], [50, 0]);

  const renderContent = (project) => {
    if (project.type === 'image') {
      return <img fill={true} alt="imag" src={project.src} />;
    } else if (project.type === 'video') {
      return <LocalVideoEmbed  videoId={project.videoId} />;
    }
    return null;
  };

  return (
    <div ref={container} className={styles.slidingImages}>
      
      <motion.div style={{ x: x1 }} className={styles.slider}>
        {slider1.map((project, index) => (
          <div key={index} className={styles.project} style={{ backgroundColor: project.color }}>
            <div className={styles.imageContainer}>
              {renderContent(project)}
            </div>
          </div>
        ))}
      </motion.div>
      <motion.div style={{ x: x2 }} className={styles.slider}>
        {slider2.map((project, index) => (
          <div key={index} className={styles.project} style={{ backgroundColor: project.color }}>
            <div className={styles.imageContainer}>
              {renderContent(project)}
            </div>
          </div>
        ))}
      </motion.div>
      <motion.div style={{ height }} className={styles.circleContainer}>
        <div className={styles.circle}></div>
      </motion.div>
    </div>
  );
}